<template>

    <div class="dropdown dropdown-multichoice" :class="{'disabled': this.disabled}" :id="'dropdown-multichoice-'+this.name">
        <button class="btn btn-outline-light dropdown-toggle" aria-expanded="true" data-toggle="dropdown" type="button"
            :class="{'active': this.mutChecked.length > 0 && !this.hideCountBadge, 'icon-button': this.type === 'icon-button'}">
                <i class="dropdown-icon" v-if="this.icon" :class="this.icon"></i>
                <span v-if="this.label">{{ this.label }}</span>
                <small class="bdg-count btn-primary" v-if="this.mutChecked.length > 0 && !this.hideCountBadge">{{ this.mutChecked.length }}</small>
        </button>
        <div class="dropdown-menu" :class="{'dropdown-menu-right': this.alignRight}">
            <div class="bg-light dropdown-item px-3 pt-3 pb-2 noselect">
                <h5>{{ this.title }}</h5>
                <a class="text-dark check-uncheck-link" @click="checkUncheckAll()">{{ trans('check-uncheck-all') }}</a>
            </div>

            <div class="dropdown-menu-content" :class="{'has-submit': hasSubmit() || hasReset()}">
                <div class="dropdown-item p-0" v-for="(item) in options">
                    <div class="form-group form-check">
                        <input class="form-check-input" type="checkbox"
                            :name="getInputName(item)"
                            :value="item.value"
                            :id="getInputId(item)"
                            :checked="itemChecked(item)"
                            @change="itemChange(item)">

                        <label class="form-check-label" :for="getInputId(item)">{{ item.label }}</label>
                    </div>
                </div>

                <div class="dropdown-btns">
                    <button class="btn btn-danger" v-if="hasReset()" @click="reset()" :disabled="disabled">
                        <i class="far fa-undo fa-fw mr-2"></i>
                        {{ trans('reset') }}
                    </button>
                    <button class="btn btn-primary" v-if="hasSubmit()" @click="submit()" :disabled="disabled || this.mutChecked.length === 0">
                        <i class="far fa-check fa-fw mr-2"></i>
                        {{ trans('save') }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {cloneDeep} from "lodash";
    import TranslationsUtils from "../../app-components/TranslationsUtils";

    export default {
        mixins: [TranslationsUtils],
        props: {
            'type': { // form-control | icon-button
                type: String,
                default: 'form-control'
            },
            'name': {
                type: String
            },
            'icon': {
                type: String
            },
            'label': {
                type: String
            },
            'title': {
                type: String
            },
            'options': {
                type: Array
            },
            'checked': {
                type: Array,
                default: function() {
                    return [];
                }
            },
            'disabled': {
                type: Boolean,
                default: false
            },
            'hideCountBadge': {
                type: Boolean,
                default: false
            },
            'alignRight': {
                type: Boolean,
                default: false
            },
            'onchange': { type: Function },
            'onsubmit': { type: Function },
            'onreset': { type: Function },
            'resetTrigger': { type: Number }
        },

        data() {
            return {
                'mutChecked': cloneDeep(this.checked),
            };
        },

        methods: {
            getInputId(item) {
                return this.name + '-' + item.value;
            },
            getInputName(item) {
                return this.name + '[' + item.value + ']';
            },

            itemChecked(item) {
                return this.mutChecked.includes(item.value);
            },

            itemChange(item) {
                if (this.mutChecked.includes(item.value)) {
                    this.mutChecked.splice(this.mutChecked.indexOf(item.value), 1);
                } else {
                    this.mutChecked.push(item.value);
                }

                this.triggerChange();
            },

            hasSubmit() {
                return typeof this.onsubmit !== 'undefined';
            },

            submit() {
                if(this.hasSubmit()) {
                    this.onsubmit(this.mutChecked);
                }
                this.closeDropdown();
            },

            hasReset() {
                return typeof this.onreset !== 'undefined';
            },

            reset() {
                if(this.hasReset()) {
                    this.onsubmit([]);
                }
                this.closeDropdown();
            },

            updateCheckedItems(checkedItems) {
                this.mutChecked = cloneDeep(checkedItems);
            },

            closeDropdown() {
                this.$el.classList.remove('open');
            },

            checkUncheckAll() {
                if(this.mutChecked.length === this.options.length) {
                    this.mutChecked = [];
                } else {
                    this.mutChecked = this.options.map((option) => {
                        return option.value;
                    });
                }

                this.triggerChange();
            },

            triggerChange() {
                if (this.onchange) {
                    this.onchange(this.name, this.mutChecked);
                }
            }
        },

        watch: {
            resetTrigger() {
                this.mutChecked = cloneDeep(this.checked);
            }
        }
    }
</script>


<style lang="scss">
    .dropdown-multichoice {
        width: 100%;

        &.disabled {
            opacity: 0.7;
            pointer-events: none;
        }

        .dropdown-toggle {
            color: #3e515b;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            border: 1px solid #b9c8de;
            border-radius: 0;
            background: white;

            &.active {
                padding-right: 40px;
                color: #343A40;
            }

            .bdg-count {
                position: absolute;
                right: 5px;
                top: 5px;
                padding: 5px 8px;
                border-radius: 3px;
            }

            &.icon-button {
                border: 0;
                background: none;
                width: auto;
            }
        }

        .dropdown-menu {
            h5 {
                font-weight: bold;
                padding: 0px;
                font-size: 0.9rem;
                user-select: none;
            }
            .check-uncheck-link {
                padding: 0px;
                margin: 0px;
                font-size: 0.7rem;
                cursor: pointer;
                user-select: none;
                text-decoration: underline;
            }

            .dropdown-menu-content {
                max-height: 40vh;
                overflow-y: auto;

                &.has-submit {
                    padding-bottom: 36px;
                }
            }

            .form-check {
                margin: 0px;

                .form-check-label {
                     display: block;
                     margin: 0px;
                     padding: 10px 10px 10px 50px;
                     user-select: none;

                     &:before {
                        top: 10px;
                        left: 15px;
                     }
                     &:after {
                        top: 15px;
                        left: 20px;
                     }
                }
            }

            .dropdown-btns {
                display: flex;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: white;

                .btn {
                    border-radius: 0;
                    display: block;
                    cursor: pointer;
                    color: white;
                    min-width: 50%;
                    flex-grow: 1;

                    .far { color: white !important; }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/DropdownMultichoice.vue